import Cookies from 'js-cookie';
import { merge } from 'lodash-es';
import { defineComponent, h, onMounted, ref } from 'vue';
import { COOKIE_NAME, addCookieValue, findPersonalizationCookie } from './personalization-cookie-match.ts';

export function setPersonalizationCookie(service) {
    const value = service.login_personalization;
    if (typeof value !== 'string' || !value.trim()) return;

    Cookies.set(COOKIE_NAME, addCookieValue(Cookies.get(COOKIE_NAME), value.trim()), {
        expires: 30,
        path: '/',
        sameSite: 'Lax',
    });
}

export function personalizeSliceProps(props) {
    const item = findPersonalizationCookie(props.personalization?.cookie || []);
    if (!item?.data) return props;

    const { translations, ...content } = item.data;
    const override = merge({}, content, translations);
    const result = merge({}, props, override);

    // Slices using l10n merge translations over props again inside the component.
    if (props.translations || translations) {
        result.translations = merge({}, props.translations, override);
    }

    return result;
}

export function withPersonalizationCookie(component) {
    // Trial forms resolve cookie rules themselves, after query/referrer rules,
    // and can replace the configuration for the current registration step.
    if (component.mixins?.some((mixin) => mixin.handlesPersonalizationCookie)) return component;

    return defineComponent({
        name: `CookiePersonalized${component.name || 'Slice'}`,
        inheritAttrs: false,
        setup(_, { attrs, slots }) {
            const isMounted = ref(false);
            onMounted(() => {
                isMounted.value = true;
            });

            return () => h(component, isMounted.value ? personalizeSliceProps(attrs) : attrs, slots);
        },
    });
}
